import { useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import CreateContact from "./CreateContact";
import ContactFilter from "./ContactFilter";
import ContactTable from "./ContactTable";

export default function Dashboard() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [FormOpener, setFormOpener] = useState(false);
  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };
  const handleFormClose = (e) => {
    e.preventDefault();
    setFormOpener(!FormOpener);
  };

  window.location.href = "/courses";

  return (
    <>
      <Header Page={"Contacts"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}

          <div className="container-fluid">
            <div className="heading-title">
              <div className="row">
                <div className="col-md-12">
                  <div className="home-table-search">
                    <div className="input-group search-contacts">
                      <input
                        type="Search"
                        className="form-control"
                        placeholder="search contacts"
                      />
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </div>
                    <div className="right-click Create-btn">
                      <a
                        className="btn create-contact"
                        onClick={handleFormClose}
                      >
                        Create Contact
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/*<!-- /filter-in-mob-view -->*/}
                  <ContactFilter />
                </div>
                {/*<!-- Contact Table -->*/}
                <ContactTable />
              </div>
            </div>

            <CreateContact
              FormOpener={FormOpener}
              handleFormClose={handleFormClose}
            />
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
